import { LoadingStatuses } from 'core/common/entities';
import { PhotoScan } from '../entities';

export type ScanState = {
  detectProcessingStatus: LoadingStatuses;
  uploadProcessingStatus: LoadingStatuses;
  data: PhotoScan;
};

export const scanInitialState: ScanState = {
  detectProcessingStatus: LoadingStatuses.IDLE,
  uploadProcessingStatus: LoadingStatuses.IDLE,
  data: {
    photoId: '',
    photo: '',
    coordinates: {
      lifeLinePts: [],
      heartLinePts: [],
      marriageLinePts: [],
      headLinePts: [],
      moneyLinePts: [],
      thumbFingerTip: { x: '', y: '' },
      indexFingerTip: { x: '', y: '' },
      middleFingerTip: { x: '', y: '' },
      ringFingerTip: { x: '', y: '' },
      pinkyFingerTip: { x: '', y: '' },
    },
  },
};
